import { render, staticRenderFns } from "./statisticsDetails.vue?vue&type=template&id=4a34ed68&scoped=true"
import script from "./statisticsDetails.vue?vue&type=script&lang=js"
export * from "./statisticsDetails.vue?vue&type=script&lang=js"
import style0 from "./statisticsDetails.vue?vue&type=style&index=0&id=4a34ed68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34ed68",
  null
  
)

export default component.exports